export const getInitialTimespan = (): string => {
  const userAsString = localStorage.getItem("user");

  if (userAsString) {
    const user = JSON.parse(userAsString);

    const weeklyCasesFeature = user.features?.find?.(feature => feature.name === "weeklyCases");

    if (weeklyCasesFeature?.enabled) {
      return "week";
    }
  }

  return "month";
};
